module.exports = __webpack_public_path__ + "asset/image-iconCategoryHealth-f328892d6d883fb3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/component/category-icon/image/iconCategoryHealth.svg
// module id = YB0b
// module chunks = 0